<template>
  <section>
    <b-card v-if="_products.length === 0">
      <div class="text-muted">
        Kayıt bulunamadı.
      </div>
    </b-card>

    <div
      v-for="(product, pIndex) in _products"
      :key="product.id"
    >
      <b-card>
        <ProductMatchProduct
          v-for="(tyProduct, tyIndex) in product.ty_all_products"
          :key="tyIndex"
          :tyProduct="tyProduct"
          :tyIndex="tyIndex"
          :product="product"
          :pIndex="pIndex"
        />
      </b-card>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductMatchProduct from './ProductMatchProduct.vue'

export default {
  name: 'ProductMatchProducts',
  components: {
    ProductMatchProduct,
  },
  computed: {
    ...mapGetters('tyProductMatch', ['_products']),
  },
}
</script>
